import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { APIOrganizationWithRoleAndPlan } from '../../../../../../../../typings/Organization.interface';
import { APITeam, APITeamWithRole } from '../../../../../../../../typings/Team.interface';
import { capitalizeFirstLetter } from '../../../../../utils';
import Avatar from '../../../../common/base/Avatar';
import Badge from '../../../../common/base/Badge';
import { ClickableArea } from '../../../../common/base/Button';
import { StyledCardSection } from '../../../../common/base/Card';
import Divider from '../../../../common/base/Divider';
import Icon from '../../../../common/base/Icon';
import Text from '../../../../common/base/Text';
import Tooltip from '../../../../common/base/Tooltip';
import { Div, StyledUtilsProps } from '../../../../common/helpers/StyledUtils';
import Search from '../../../../common/Search';
import { DashboardContext } from '../../DashboardContext';
const StyledScrollableArea = styled(Div)`
  flex-grow: 1;
  overflow-y: auto;
  max-height: calc(90vh - 100px);
  box-sizing: border-box;
  flex-grow: 1;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const StyledProjectContent = styled(Div)(({
  theme
}) => css`
    width: 600px;
    display: grid;
    grid-template-columns: 300px 300px;
    > div:first-child {
      border-right: ${theme.border};
      ${StyledCardSection}:first-of-type {
        border-radius: ${theme.radius.normal_inset} 0 0 0;
      }
    }

    > div:last-child {
      ${StyledCardSection}:first-of-type {
        border-radius: 0 ${theme.radius.normal_inset} 0 0;
      }
    }

    > div > ${StyledCardSection}:not(:first-child) {
      border-top: ${theme.border};
    }
  `);
export interface TeamSelectionListFooterProps {
  focused_organization_id: string | null;
}
export interface TeamSelectionListProps extends Pick<StyledUtilsProps, 'h'> {
  organizations: APIOrganizationWithRoleAndPlan[] | null | undefined;
  teams: APITeamWithRole[] | null | undefined;
  selected_team_id?: string | null;
  onTeamSelect: (team: APITeamWithRole, previous_team?: APITeam | null) => void;
  default_organization_id?: string | null;
  footer?: (props: TeamSelectionListFooterProps) => {
    organizations?: React.ReactNode;
    teams?: React.ReactNode;
  };
}
const TeamSelectionList: React.FC<TeamSelectionListProps> = t0 => {
  const $ = _c(93);
  const {
    h,
    organizations,
    teams,
    selected_team_id,
    onTeamSelect,
    default_organization_id,
    footer
  } = t0;
  const [org_search, setOrgSearch] = useState("");
  const [team_search, setTeamSearch] = useState("");
  const {
    team
  } = useContext(DashboardContext);
  let t1;
  if ($[0] !== selected_team_id || $[1] !== teams) {
    t1 = selected_team_id ? teams?.find(t => t.id === selected_team_id) : null;
    $[0] = selected_team_id;
    $[1] = teams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selected_team = t1;
  const initial_organization_id = selected_team?.organization_id || default_organization_id || organizations?.[0]?.id || null;
  const [selected_organization, setSelectedOrganization] = useState(initial_organization_id);
  let t2;
  if ($[3] !== selected_team) {
    t2 = () => {
      if (selected_team?.organization_id) {
        setSelectedOrganization(selected_team.organization_id);
      }
    };
    $[3] = selected_team;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = selected_team?.organization_id;
  let t4;
  if ($[5] !== t3) {
    t4 = [t3];
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useEffect(t2, t4);
  let T0;
  let T1;
  let T2;
  let T3;
  let event_gateway_projects;
  let filtered_organizations;
  let filtered_teams;
  let footer_content;
  let outpost_projects;
  let t10;
  let t11;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[7] !== footer || $[8] !== h || $[9] !== org_search || $[10] !== organizations || $[11] !== selected_organization || $[12] !== team_search || $[13] !== teams) {
    filtered_organizations = organizations?.filter(org => org_search.length > 0 ? org.name.toLowerCase().indexOf(org_search.toLowerCase()) >= 0 : true);
    const focused_organization = filtered_organizations && (filtered_organizations.find(org_0 => org_0.id === selected_organization) || filtered_organizations[0]);
    filtered_teams = focused_organization && selected_organization && teams?.filter(team_0 => team_0.organization_id === focused_organization.id);
    const filtered_teams_searched = filtered_teams && filtered_teams.filter(team_1 => team_search.length > 0 ? team_1.name.toLowerCase().indexOf(team_search.toLowerCase()) >= 0 : true);
    event_gateway_projects = filtered_teams_searched && focused_organization && filtered_teams_searched.filter(t_0 => t_0.organization_id === focused_organization.id && t_0.type !== "outpost").sort(_temp);
    outpost_projects = filtered_teams_searched && focused_organization && filtered_teams_searched.filter(t_1 => t_1.organization_id === focused_organization.id && t_1.type === "outpost").sort(_temp2);
    footer_content = footer?.({
      focused_organization_id: focused_organization?.id || null
    });
    T3 = StyledProjectContent;
    T2 = Div;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = {
        direction: "column"
      };
      $[30] = t11;
    } else {
      t11 = $[30];
    }
    T1 = StyledCardSection;
    if ($[31] !== org_search) {
      t9 = <Search name="org_search" borderless={true} small={true} placeholder="Find an organization" value={org_search} onChange={setOrgSearch} />;
      $[31] = org_search;
      $[32] = t9;
    } else {
      t9 = $[32];
    }
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <Divider />;
      $[33] = t10;
    } else {
      t10 = $[33];
    }
    T0 = StyledScrollableArea;
    t5 = 1;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        direction: "column",
        gap: 0.25
      };
      $[34] = t6;
    } else {
      t6 = $[34];
    }
    t7 = h ?? undefined;
    t8 = filtered_organizations && filtered_organizations.sort(_temp3).map(other_organization => <ClickableArea key={other_organization.id} onClick={() => setSelectedOrganization(other_organization.id)} p={{
      y: 1.5,
      x: 2
    }} rounded={true} flex={{
      align: "center",
      gap: 2
    }}><Avatar name={other_organization.name} xsmall={true} /><Text ellipsis={true}>{other_organization.name}</Text><Badge neutral={true} subtle={true}>{capitalizeFirstLetter(other_organization.role)}</Badge>{other_organization.id === selected_organization && <Div m={{
        l: "auto"
      }}><Icon primary={true} icon="success" pointer={true} /></Div>}</ClickableArea>);
    $[7] = footer;
    $[8] = h;
    $[9] = org_search;
    $[10] = organizations;
    $[11] = selected_organization;
    $[12] = team_search;
    $[13] = teams;
    $[14] = T0;
    $[15] = T1;
    $[16] = T2;
    $[17] = T3;
    $[18] = event_gateway_projects;
    $[19] = filtered_organizations;
    $[20] = filtered_teams;
    $[21] = footer_content;
    $[22] = outpost_projects;
    $[23] = t10;
    $[24] = t11;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    T0 = $[14];
    T1 = $[15];
    T2 = $[16];
    T3 = $[17];
    event_gateway_projects = $[18];
    filtered_organizations = $[19];
    filtered_teams = $[20];
    footer_content = $[21];
    outpost_projects = $[22];
    t10 = $[23];
    t11 = $[24];
    t5 = $[25];
    t6 = $[26];
    t7 = $[27];
    t8 = $[28];
    t9 = $[29];
  }
  let t12;
  if ($[35] !== filtered_organizations) {
    t12 = filtered_organizations && filtered_organizations.length === 0 && <Text muted={true} m={{
      x: 2,
      y: 1.5
    }}>No organizations found.</Text>;
    $[35] = filtered_organizations;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== T0 || $[38] !== t12 || $[39] !== t5 || $[40] !== t6 || $[41] !== t7 || $[42] !== t8) {
    t13 = <T0 p={t5} flex={t6} h={t7}>{t8}{t12}</T0>;
    $[37] = T0;
    $[38] = t12;
    $[39] = t5;
    $[40] = t6;
    $[41] = t7;
    $[42] = t8;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== T1 || $[45] !== t10 || $[46] !== t13 || $[47] !== t9) {
    t14 = <T1>{t9}{t10}{t13}</T1>;
    $[44] = T1;
    $[45] = t10;
    $[46] = t13;
    $[47] = t9;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  const t15 = footer_content?.organizations;
  let t16;
  if ($[49] !== T2 || $[50] !== t11 || $[51] !== t14 || $[52] !== t15) {
    t16 = <T2 flex={t11}>{t14}{t15}</T2>;
    $[49] = T2;
    $[50] = t11;
    $[51] = t14;
    $[52] = t15;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  let t17;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      direction: "column"
    };
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  let t18;
  if ($[55] !== team_search) {
    t18 = <Search name="team_search" borderless={true} small={true} placeholder="Find a project" value={team_search} onChange={setTeamSearch} />;
    $[55] = team_search;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Divider />;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  const t20 = h ?? undefined;
  let t21;
  if ($[58] !== event_gateway_projects || $[59] !== onTeamSelect || $[60] !== outpost_projects || $[61] !== selected_team_id || $[62] !== team) {
    t21 = event_gateway_projects && event_gateway_projects.length > 0 && <>{outpost_projects && outpost_projects.length > 0 && <Div flex={{
        align: "center",
        gap: 2
      }} p={{
        t: 1.5,
        x: 2
      }}><Text muted={true} semi={true} size="xs" uppercase={true}>Event Gateway</Text></Div>}<Div flex={{
        direction: "column",
        gap: 0.25
      }}>{event_gateway_projects.map(other_team => <ClickableArea key={other_team.id} onClick={() => onTeamSelect(other_team, team)} p={{
          y: 1.5,
          x: 2
        }} rounded={true} flex={{
          align: "center",
          gap: 2
        }}>{other_team.private ? <Tooltip tooltip="Private project" side="bottom"><Icon muted={true} icon="folder_private" pointer={true} /></Tooltip> : <Icon icon="folder" muted={true} pointer={true} />}<Text ellipsis={true}>{other_team.name}</Text><Badge neutral={true} subtle={true}>{capitalizeFirstLetter(other_team.role)}</Badge>{other_team.id === selected_team_id && <Div flex={{
            align: "center",
            gap: 2
          }} m={{
            l: "auto"
          }}><Icon primary={true} icon="success" pointer={true} /></Div>}</ClickableArea>)}</Div></>;
    $[58] = event_gateway_projects;
    $[59] = onTeamSelect;
    $[60] = outpost_projects;
    $[61] = selected_team_id;
    $[62] = team;
    $[63] = t21;
  } else {
    t21 = $[63];
  }
  let t22;
  if ($[64] !== event_gateway_projects || $[65] !== onTeamSelect || $[66] !== outpost_projects || $[67] !== selected_team_id || $[68] !== team) {
    t22 = outpost_projects && outpost_projects.length > 0 && <>{event_gateway_projects && event_gateway_projects.length > 0 && <Div flex={{
        align: "center",
        gap: 2
      }} p={{
        t: 1.5,
        x: 2
      }}><Text muted={true} semi={true} size="xs" uppercase={true}>Outpost</Text></Div>}<Div flex={{
        direction: "column",
        gap: 0.25
      }}>{outpost_projects.map(other_team_0 => <ClickableArea key={other_team_0.id} onClick={() => onTeamSelect(other_team_0, team)} p={{
          y: 1.5,
          x: 2
        }} rounded={true} flex={{
          align: "center",
          gap: 2
        }}>{other_team_0.private ? <Tooltip tooltip="Private project" side="bottom"><Icon muted={true} icon="folder_private" pointer={true} /></Tooltip> : <Icon icon="folder" muted={true} pointer={true} />}<Text ellipsis={true}>{other_team_0.name}</Text><Badge neutral={true} subtle={true}>{capitalizeFirstLetter(other_team_0.role)}</Badge>{other_team_0.id === selected_team_id && <Div flex={{
            align: "center",
            gap: 2
          }} m={{
            l: "auto"
          }}><Icon primary={true} icon="success" pointer={true} /></Div>}</ClickableArea>)}</Div></>;
    $[64] = event_gateway_projects;
    $[65] = onTeamSelect;
    $[66] = outpost_projects;
    $[67] = selected_team_id;
    $[68] = team;
    $[69] = t22;
  } else {
    t22 = $[69];
  }
  let t23;
  if ($[70] !== filtered_organizations?.length || $[71] !== selected_organization) {
    t23 = (!selected_organization || filtered_organizations?.length === 0) && <Text muted={true} m={{
      x: 2,
      y: 1.5
    }}>Select organization to view projects.</Text>;
    $[70] = filtered_organizations?.length;
    $[71] = selected_organization;
    $[72] = t23;
  } else {
    t23 = $[72];
  }
  let t24;
  if ($[73] !== filtered_teams || $[74] !== org_search || $[75] !== team_search) {
    t24 = filtered_teams && filtered_teams.length === 0 && !org_search && !team_search && <Div flex={{
      align: "flex-start"
    }} m={{
      x: 2,
      y: 1.5
    }}><Icon icon="info" muted={true} left={true} p={0.5} /><Text muted={true} size="s">No projects within this organization, create a new project below.</Text></Div>;
    $[73] = filtered_teams;
    $[74] = org_search;
    $[75] = team_search;
    $[76] = t24;
  } else {
    t24 = $[76];
  }
  let t25;
  if ($[77] !== t20 || $[78] !== t21 || $[79] !== t22 || $[80] !== t23 || $[81] !== t24) {
    t25 = <StyledScrollableArea p={1} h={t20}>{t21}{t22}{t23}{t24}</StyledScrollableArea>;
    $[77] = t20;
    $[78] = t21;
    $[79] = t22;
    $[80] = t23;
    $[81] = t24;
    $[82] = t25;
  } else {
    t25 = $[82];
  }
  let t26;
  if ($[83] !== t18 || $[84] !== t25) {
    t26 = <StyledCardSection>{t18}{t19}{t25}</StyledCardSection>;
    $[83] = t18;
    $[84] = t25;
    $[85] = t26;
  } else {
    t26 = $[85];
  }
  const t27 = footer_content?.teams;
  let t28;
  if ($[86] !== t26 || $[87] !== t27) {
    t28 = <Div flex={t17}>{t26}{t27}</Div>;
    $[86] = t26;
    $[87] = t27;
    $[88] = t28;
  } else {
    t28 = $[88];
  }
  let t29;
  if ($[89] !== T3 || $[90] !== t16 || $[91] !== t28) {
    t29 = <T3>{t16}{t28}</T3>;
    $[89] = T3;
    $[90] = t16;
    $[91] = t28;
    $[92] = t29;
  } else {
    t29 = $[92];
  }
  return t29;
};
export default TeamSelectionList;
function _temp(a, b) {
  return a.name > b.name ? 1 : -1;
}
function _temp2(a_0, b_0) {
  return a_0.name > b_0.name ? 1 : -1;
}
function _temp3(a_1, b_1) {
  return a_1.name.localeCompare(b_1.name);
}